let showMoreButton = document.getElementById('mehr-anzeigen-palette')
let showMoreButtonReWorks = document.getElementById('mehr-anzeigen-reworks')

if(showMoreButton) {
    showMoreButton.addEventListener('click', function() {
        let palettenText = document.getElementById('paletten-text');
        let palettenWraps = palettenText.querySelectorAll('.wrap');
        
        for (let wrap of palettenWraps) {
            wrap.classList.add('visible');
        }
        showMoreButton.style.display = "none"

    })
}

if(showMoreButtonReWorks) {
    showMoreButtonReWorks.addEventListener('click', function() {
        let reworks = document.getElementById('reworks');
        let palettenWraps = reworks.querySelectorAll('.row');
        
        for (let wrap of palettenWraps) {
            wrap.classList.remove('hidden');
        }
        showMoreButtonReWorks.style.display = "none"

    })
}